import React, { useEffect, useCallback, useState, useRef } from "react";
import { useParams } from 'react-router-dom';
import server from "../../../api/server";
import { useNavigate } from "react-router-dom";
import { MdArrowBack, MdOutlineDescription } from 'react-icons/md';
import { IoIosCall, IoIosPersonAdd } from "react-icons/io";
import FeedbackSection from "../../../dashboard-components/layouts/FeedbackSection.jsx"
import { MdOutlineExpandMore } from "react-icons/md";
import { MdOutlineExpandLess } from "react-icons/md";
import { RiMapPinTimeLine, RiSurveyLine } from "react-icons/ri";
import { MdDensitySmall } from "react-icons/md";
import { PiWarningCircle } from "react-icons/pi";
import { FaEye, FaTimes } from "react-icons/fa";
import { IoIosCloseCircleOutline } from "react-icons/io";
import CallDetails from "../calls/CallDetails.jsx";

import { 
    FaLightbulb, 
    FaUser, 
    FaQuestionCircle 
  } from "react-icons/fa";
import '../../../dashboard-components/loader.css';
import { IoChatbubbleOutline, IoChatbubbleSharp } from "react-icons/io5";
import { ChevronsLeft, ChevronsRight, Menu, PencilLine } from "lucide-react";

const CustomerDetails = ({selectedOption, selectedClientId, customerIdProp, open_type}) => {
    const { customerId } = useParams();
    const [client_id, setClient_id] = useState(null);
    const [service_id, setService_id] = useState(null)
    const [email, setEmail] = useState(null)
    const [sections, setSections] = useState([])
    const [showMoreMap, setShowMoreMap] = useState({});
    const [expandedSection, setExpandedSection] = useState(0);
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState(null)
    const [showSummary, setShowSummary] = useState({});
    const [selectedCallID, setSelectedCallID] = useState(null)
    const [showConversationPage, setShowConversationPage] = useState(false)
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);
    const tabRowRef = useRef(null);
    const navigate = useNavigate();
    const [selectedSection, setSelectedSection] = useState(null);
    const [selectedSegment, setSelectedSegment] = useState(null);
    const [selectedTab, setSelectedTab] = useState(null);
    // Compute filteredSections once per render
  const filteredSections = sections.filter(section => Array.isArray(section.data) ? section.data.length > 0 : section.data);

  // Ensure selectedSection is always in sync with filteredSections
  useEffect(() => {
    if (filteredSections.length > 0) {
      // If expandedSection is null or out of bounds, default to first
      const idx = (expandedSection != null && expandedSection < filteredSections.length) ? expandedSection : null;
      setSelectedSection(filteredSections[idx]);
    } else {
      setSelectedSection(null);
    }
    // eslint-disable-next-line
  }, [sections, expandedSection]);
    function getCookie(name) {
        function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
        var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
        return match ? match[1] : null;
    }
    const toggleSummary = (index) => {
        setShowSummary(prevState => ({
            ...prevState,
            [index]: !prevState[index]
        }));
    };
    const debounce = (func, delay) => {
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => func(...args), delay);
        };
      };
      const selectedOptionRef = useRef(selectedOption);
        selectedOptionRef.current = selectedOption;

      const getCustomerDetails = async () => {
        setLoading(true)
        const user = getCookie("dashboard_login_user_creds")
          ? JSON.parse(getCookie("dashboard_login_user_creds"))
          : null;
    
        if (user) {
          let clientId = selectedClientId;
          let email = user.email
          // Decode the customerId if it comes from URL params (it would be encoded)
          const actualCustomerId = customerIdProp ? customerIdProp : (customerId ? decodeURIComponent(customerId) : customerId);
          setClient_id(clientId)
          try {
            let res = await server.get_voice_agent_customer_details(clientId, selectedOption, email, "customers", undefined, actualCustomerId);
            if(res.status === 200){
                let resp = await res.json();
                setData(resp.data);
                setSections([
                  {title: "Overview", dataKey: "voice_agent_customerOverview", data: {...resp.data?.metadata, customer_id: actualCustomerId}},
                  {title: "Customer Summary", dataKey: "Customer Summary", data: {'call_summary_with_source': resp.data?.customer_summary}},
                  {title: "Business Insights", dataKey: "Business Insights", data: resp.data?.business_insights}
                  ]);
            }
          } catch (error) {
          }finally{
            setLoading(false);
          }
        }
      };
      const handleGoBack = () => {
        if(customerIdProp){
          open_type();
          return;
        }
        navigate(-1); 
      }
      const gotoCalls = (call_id) => {
        // if(customerIdProp){
          setShowConversationPage(true);
          setSelectedCallID(call_id)
          
        // Properly encode the call_id to handle special characters, spaces, and other URL-unsafe characters
        // const encodedCallId = encodeURIComponent(call_id);
        // navigate(`/${selectedClientId}/${selectedOption}/conversations/${encodedCallId}?service_id=${selectedOption}`)
      }
      const handleClose = () => {
        setShowConversationPage(false)
        setSelectedCallID(null)
      }
      const toggleSection = (index) => {
        setExpandedSection((prev) => (prev === index ? index : index));
      };
      const toggleShowMore = (key) => {
        setShowMoreMap(prev => ({ ...prev, [key]: !prev[key] }));
      };
      function convertEpochToReadable(epoch_time, isMilliseconds = true, location=undefined) {
        let epoch = null
        if(!location){
          if (epoch_time && epoch_time.call_time){
            epoch = epoch_time.call_time
          }else{
            epoch = epoch_time.time
          }
        }else{
          if(location === 'First'){
            epoch = Number(epoch_time[0].time)
          }else if(location === 'Last'){
            epoch = Number(epoch_time[epoch_time.length-1].time)
          }else{
            epoch = undefined
          }
        }
        // Convert to milliseconds if the epoch is in seconds
        const date = new Date(isMilliseconds ? epoch : epoch * 1000);
    
        // Format the date as "YYYY-MM-DD HH:mm:ss"
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        
        return `${day}-${month}-${year} ${hours}:${minutes}`;
    }
    const renderIconHere = (title) => {
        switch (title) {
          case "Overview":
            return <Menu style={{marginRight: "8px", height: "16px"}}/>
          case "Customer Summary":
            return <MdOutlineDescription style={{marginRight: "5px", fontSize: "19px"}}/>
          case "Business Insights":
            return <FaLightbulb style={{marginRight: "5px", fontSize: "19px"}}/>
          default:
            return null; // No icon for unmatched titles
        }
      };
    useEffect(() => {
        // Dynamically build the initial showMoreMap based on `data`
        if (data) {
          const initialShowMoreMap = {};
          initialShowMoreMap[`Customer Summary`] = false;
          initialShowMoreMap[`Business Insights`] = false;
          setShowMoreMap(initialShowMoreMap);
        }
      }, [data]);
    
    const debouncedGetCustomerDetails = useCallback(debounce(getCustomerDetails, 300), []);
    useEffect(() => {
      if (selectedOption && selectedClientId && email) {
        debouncedGetCustomerDetails();
      }
    }, [selectedOption, customerId, debouncedGetCustomerDetails, customerIdProp, email]);
    useEffect(()=> {
      if(selectedOption){
        setService_id(selectedOption)
      }
      if(selectedClientId){
        setClient_id(selectedClientId)
      }
      const user = getCookie("dashboard_login_user_creds")
        ? JSON.parse(getCookie("dashboard_login_user_creds"))
        : null;
      if(user){
        let email =user.email
        setEmail(email)
      }
    }, [selectedOption, selectedClientId])
    const checkTabRowScroll = () => {
      const el = tabRowRef.current;
      if (!el) return;
      setCanScrollLeft(el.scrollLeft > 0);
      setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    };
  
    useEffect(() => {
      checkTabRowScroll();
      const el = tabRowRef.current;
      if (!el) return;
      el.addEventListener('scroll', checkTabRowScroll);
      window.addEventListener('resize', checkTabRowScroll);
      return () => {
        el.removeEventListener('scroll', checkTabRowScroll);
        window.removeEventListener('resize', checkTabRowScroll);
      };
    }, [filteredSections.length]);
  
    const scrollTabRow = (direction) => {
      const el = tabRowRef.current;
      if (!el) return;
      const scrollAmount = 240; // px
      el.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
    };
    const handleSourceClick = (source) => {
      if(source.conversation_id){
        setShowConversationPage(true)
        setSelectedSegment(source)
        setSelectedTab(filteredSections[expandedSection].title)
        setSelectedCallID(source.conversation_id)
      }
    }
    useEffect(() => {
      const handleEsc = (event) => {
        if (event.key === "Escape") {
          setShowConversationPage(false);
        }
      }
      if (showConversationPage) {
        window.addEventListener('keydown', handleEsc);
      }
      return () => {
        window.removeEventListener('keydown', handleEsc);
      }
    }, [showConversationPage])
    return (
        <div style={{ padding: '0 1rem', width: "100%", height: (window.location.href.includes('?token=')) ? window.innerHeight : window.innerHeight - 66.5, overflowY: "auto" }} className="bg-gray-50">
            {
                    !loading && !showConversationPage && (
                      <>
                      {!window.location.href.includes('?token=') && <button onClick={handleGoBack} style={{display: 'flex',alignItems: 'center',color: '#4b5563',cursor: 'pointer',border: 'none',background: 'none',padding: '8px',fontSize: '14px',}}>
                      <MdArrowBack style={{ marginRight: '8px' }} />
                      Back
                    </button>}
                      {
                        !data ? (
                          <>
                          <div className="flex justify-center items-center" style={{ height: "100%", flexDirection: "column" }}>
                                    <img src="/assets/paper.png" style={{height: "10vh"}} alt=""/>
                                    <h2 style={{textAlign: "center", fontSize: "24px"}}>No Customers Details Found.</h2>
                                </div>
                          </>
                        ) : (
                            <div style={{display: "flex", height: (window.location.href.includes('?token=')) ? "100%" : "auto"}}>
                                <div style={{flex: "0.65", overflowY: "auto", background: "white", borderRadius: "10px 10px 0 6px"}} className='shadow-sm'>
                                  {/* Tab Row: single horizontal, scrollable, no wrap */}
                                  <div style={{position: 'relative', width: '100%'}}>
                                    {/* Left Arrow */}
                                    {canScrollLeft && (
                                      <button
                                        onClick={() => scrollTabRow('left')}
                                        style={{
                                          position: 'absolute',
                                          left: 0,
                                          top: 0,
                                          bottom: 0,
                                          zIndex: 1000000000,
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'flex-start',
                                          background: 'white',
                                          border: 'none',
                                          cursor: 'pointer',
                                          height: '97%',
                                          padding: 0,
                                          outline: 'none',
                                          transition: 'background 0.2s',
                                          pointerEvents: 'auto'
                                        }}
                                        aria-label="Scroll left"
                                      >
                                        <ChevronsLeft size={20} color="#808080" />
                                      </button>
                                    )}
                                    {/* Right Arrow */}
                                    {canScrollRight && (
                                      <button
                                        onClick={() => scrollTabRow('right')}
                                        style={{
                                          position: 'absolute',
                                          right: 0,
                                          top: 0,
                                          bottom: 0,
                                          zIndex: 1000000000,
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'flex-end',
                                          background: 'white',
                                          border: 'none',
                                          cursor: 'pointer',
                                          height: '97%',
                                          padding: 0,
                                          outline: 'none',
                                          transition: 'background 0.2s',
                                          pointerEvents: 'auto'
                                        }}
                                        aria-label="Scroll right"
                                      >
                                        <ChevronsRight size={20} color="#808080" />
                                      </button>
                                    )}
                                    <div
                                      ref={tabRowRef}
                                      style={{
                                        display: "flex",
                                        overflowX: "auto",
                                        overflowY: "hidden",
                                        whiteSpace: "nowrap",
                                        alignItems: "center",
                                        padding: "0 4px",
                                        gap: "8px",
                                        borderRadius: "6px 0 0 0",
                                        borderBottom: "1.5px solid #e3e3e3",
                                        background: "white",
                                        scrollbarWidth: "none", // Firefox
                                        msOverflowStyle: "none", // IE/Edge
                                      }}
                                      className="custom-tab-scrollbar"
                                    >
                                      {filteredSections.map((section, idx) => (
                                        <div
                                          key={section.title}
                                          className={`sections-headings${expandedSection === idx ? " expanded" : ""}`}
                                          onClick={() => toggleSection(idx)}
                                          style={{
                                            minWidth: "120px",
                                            maxWidth: "320px",
                                            width: "auto",
                                            flex: "none",
                                            margin: "0 2px",
                                            padding: "10px",
                                            borderRadius: "10px 10px 0 0",
                                            borderBottom: expandedSection === idx ? "3.5px solid #6f6ffe" : "2px solid transparent",
                                            marginBottom: expandedSection === idx ? "-1.5px" : "0",
                                            zIndex: 1,
                                            background: expandedSection === idx ? "white" : "rgba(255,255,255,0.28)",
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            overflow: "hidden",
                                            fontWeight: expandedSection === idx ? 500 : 400,
                                            color: expandedSection === idx ? "#6f6ffe" : "#222",
                                            fontSize: "15px",
                                            justifyContent: "flex-start"
                                          }}
                                          title={section.title}
                                        >
                                          {renderIconHere(section.title)}
                                          <span style={{
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            display: "inline-block",
                                            maxWidth: "220px"
                                          }}>{section.title}</span>
                                        </div>
                                      ))}
                                    </div>
                                    {/* Hide scrollbar with CSS */}
                                    <style>{`
                                      .custom-tab-scrollbar {
                                        scrollbar-width: none;
                                      }
                                      .custom-tab-scrollbar::-webkit-scrollbar {
                                        display: none;
                                      }
                                    `}</style>
                                  </div>
                                  {/* Section Content: only show selected section */}
                                  <div style={{marginTop: "10px"}}>
                                    {selectedSection && (
                                      <FeedbackSection
                                        key={selectedSection?.dataKey}
                                        dataKey={selectedSection?.dataKey}
                                        data={selectedSection?.data}
                                        metadata={selectedSection?.metadata}
                                        toggleShowMore={toggleShowMore}
                                        showMoreMap={showMoreMap}
                                        source_click={handleSourceClick}
                                      />
                                    )}
                                  </div>
                                </div>
                                <div style={{flex: "0.35"}}>
                                    <div style={{display: "flex", flexDirection: "column"}}>
                                        <div style={{display: "flex", flexDirection: "column", background: "white", borderRadius: "10px 10px 6px 0px", marginLeft: "10px", height: (!window.location.href.includes('?token=')) ? "87vh" : "100vh"}}>
                                            <div style={{display: "flex", alignItems: "center", fontSize: "16px", fontWeight: "500", padding: "0.5rem 0", paddingLeft: "0.5rem", borderBottom: "1px solid rgb(214, 214, 214)", borderRadius: "10px 10px 0 0", height: "46px" }}><RiMapPinTimeLine style={{marginRight: "10px"}}/>Timeline</div>
                                            <div style={{overflowY: "auto"}}>
                                                {
                                                    data.timeline && data.timeline.length > 0 && (
                                                        <div className="timeline">
                                                            <div className="timeline-line" />
                                                            {data.timeline.sort((a, b) => new Date(a.time) - new Date(b.time)).map((item, index) => (
                                                                <div key={index} className={`feedback-item call`}>
                                                                    <div className={`status-indicator call`}>
                                                                        {item.type === 'call' && <IoIosCall className="text-indigo-600"/>}
                                                                        {item.type === 'chat' && <IoChatbubbleOutline className="text-indigo-600"/>}
                                                                    </div>
                                                                    <div style={{padding: "7px", marginLeft: "2rem", borderRadius:"6px", marginTop: "10px", background: "#ffffff47", marginRight: "10px", marginBottom: "10px"}} className={`${item.type} border`}>
                                                                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                                                            <div style={{fontSize: "9px"}}><span style={{ padding: "4px 4px", borderRadius: "10px", background: "rgba(218, 220, 224, 0.46)"}}>{item.type}</span>
                                                                            <span style={{marginLeft: "0.2rem", padding: "4px 4px", borderRadius: "10px", background: "rgba(218, 220, 224, 0.46)"}}>{item.employee_id}</span>
                                                                            {item.outcome && <span style={{marginLeft: "0.2rem", padding: "4px 4px", borderRadius: "10px", background: "rgba(218, 220, 224, 0.46)"}}>{item.outcome}</span>}
                                                                            {item.conversation_direction && <span style={{marginLeft: "0.2rem", padding: "4px 4px", borderRadius: "10px", background: "rgba(218, 220, 224, 0.46)"}}>{item.conversation_direction }</span>}
                                                                            {item.conversation_type && <span style={{marginLeft: "0.2rem", padding: "4px 4px", borderRadius: "10px", background: "rgba(218, 220, 224, 0.46)"}}>{item.conversation_type}</span>}
                                                                            </div>
                                                                            <div style={{color: "grey", fontSize: "12px"}}>
                                                                                {convertEpochToReadable(item, false)}
                                                                            </div>
                                                                        </div>
                                                                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "6px", marginLeft: "8px"}}>
                                                                            <div style={{fontSize: "14px"}}>{item.id}</div>
                                                                            <div style={{display: "flex", alignItems: "center"}}>
                                                                              <div onClick={() => toggleSummary(index)}>
                                                                                {
                                                                                  showSummary[index] ? <IoIosCloseCircleOutline style={{marginRight: "10px", cursor: "pointer"}}/> : <FaEye style={{marginRight: "10px", cursor: "pointer"}}/>
                                                                                }
                                                                              </div>
                                                                              <div onClick={() => gotoCalls(item.id)} className="view-details-btn">View Details</div>
                                                                            </div>
                                                                        </div>
                                                                        {
                                                                          showSummary[index] && (
                                                                              <>
                                                                                  <hr style={{margin:"5px"}}/>
                                                                                  <div style={{fontSize: "14px"}}>
                                                                                      <div>Summary: </div>
                                                                                      <div style={{color: "#5d6467", fontWeight: "500"}}>
                                                                                          {item.summary_short ? item.summary_short : item.summary}
                                                                                      </div>
                                                                                  </div>
                                                                              </>
                                                                          )
                                                                      }
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                        }
                    </>)}
                    {
                        loading && !showConversationPage && (
                            <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                                <div className="loader"></div>
                                <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                            </div>
                        )
                    }
                    {
                      showConversationPage && (
                        <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "1001"}}>
                        <div style={{position: "fixed", left: "2%", top: "3.5%", width: "96%", height: "93%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
                        zIndex: "999999999", padding: "5px"}}>
                            <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={()=>{setShowConversationPage(false); setSelectedSegment(null); setSelectedTab(null); setSelectedCallID(null);}}><FaTimes style={{color: "slategray"}}/></div>
                            <div style={{overflow: "auto", height: "100%"}}>
                              <CallDetails selectedOption={service_id} open_type={handleClose} callIdProp={selectedCallID} selectedClientId={client_id} selectedSegment={selectedSegment} selectedTab={selectedTab}/>
                            </div>
                        </div>
                        </div>
                      )
                    }
                    <style jsx>
                        {`
                            .timeline {
                                position: relative;
                            }

                            .timeline-line {
                                position: absolute;
                                left: 1rem;
                                top: 0;
                                bottom: 0;
                                width: 2px;
                                background-color: #e5e7eb;
                            }
                            .status-indicator {
                                position: absolute;
                                left: 0.25rem;
                                width: 1.5rem;
                                height: 1.5rem;
                                border-radius: 50%;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.875rem;
                                margin-top: 24px;
                            }

                            .status-indicator.call {
                                background-color: white;
                                color: black;
                            }

                            .status-indicator.ticket {
                                background-color: #fefce8;
                                color: #a16207;
                            }
                            .view-details-btn {
                                transition: background-color 0.3s, color 0.3s, box-shadow 0.3s;
                                border: 1px solid rgb(209 213 217);
                                width: 90px;
                                font-size: 12px;
                                text-align: center;
                                padding: 3px;
                                border-radius: 6px;
                                cursor: pointer;
                                background: white;
                            }

                            .view-details-btn:hover {
                                background: rgb(249, 250, 251);
                            }
                            .sections-headings {
                            cursor: pointer;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding: 10px;
                            background: rgba(255, 255, 255, 0.28);
                            border-radius: 10px;
                            transition: background 0.3s;
                            }

                            .sections-headings.expanded {
                            border-bottom: 1px solid rgb(227, 227, 227);
                            border-radius: 10px 10px 0 0;
                            }

                            .sections-headings:hover {
                            background: rgb(249, 250, 251);
                            }

                            .section-title {
                            font-size: 15px;
                            font-weight: 500;
                            display: flex;
                            align-items: center;
                            }

                        `}
                    </style>
        </div>
    )
}

export default CustomerDetails;
